import { ProviderLogo } from "./ProviderLogo"

interface SourceBadgeContentProps {
  name?: string
  isWebSearch?: boolean
  isKnowledgeBase?: boolean
}

const SourceBadgeContent = ({
  name,
  isWebSearch = false,
}: SourceBadgeContentProps) => {
  if (isWebSearch)
    return (
      <>
        <ProviderLogo provider="web" /> Web Search
      </>
    )

  if (!name) return null

  const displayName = name.slice(0, 20) + (name.length > 20 ? "..." : "")

  return (
    <>
      <ProviderLogo provider="knowledge_base" />
      {displayName}
    </>
  )
}

export { SourceBadgeContent }
export default SourceBadgeContent
